<template>

  <div>
    <section class="row margin-b-50">

      <header class="shop__header margin-tb-50">

        <h1>Betaling</h1>

        <p>Angiv dine kreditkort oplysninger, til betaling af din bestilling.</p>
        <p><strong>BEMÆRK</strong>, at der i bunden er angivet hvilke kort, der kan benyttes.</p>

      </header>

      <div id="payment-element" class="margin-b-50" v-show="showPaymentForm">

      </div>

      <div class="col-12" v-show="!showPaymentForm">
        <div class="spinner--dark center">

        </div>
      </div>

      <section class="row border-t margin-t-25 padding-tb-50">

        <a class="margin-t-15 pull-left" href="#" @click.prevent="goBack">Gå tilbage</a>

        <a href="#" class="btn--primary pull-right" @click.prevent="pay" :class="{'disabled':isLoading || !isValidated}" :disabled="isLoading || !isValidated">

              <span>

                  <i class="spinner--light" v-if="isLoading"></i>

                  {{submitLabel}}

              </span>

        </a>

      </section>

      <section class="col-12">

        <div class="card-list">

          <img src="/images/visa-icon.svg" alt="Visa"/>
          <img src="/images/mastercard-icon.svg" alt="Mastercard"/>
          <img src="/images/discover-icon.svg" alt="Discover"/>
          <img src="/images/jcb-icon.svg" alt="JCB"/>
          <img src="/images/diners-club-icon.svg" alt="Diners Club"/>
          <img src="/images/american-express-icon.svg" alt="American Express"/>

          <a class="payment" title="Besøg Stripe" target="_blank" href="https://stripe.com/dk"><img src="/images/stripe-logo.svg" alt="Stripe Logo"></a>

        </div>

      </section>

      <section class="col-12 margin-tb-25">

        <p><strong>OBS!</strong> Vi modtager <strong>IKKE alm. Dankort</strong> i shoppen.</p>

      </section>

    </section>
  </div>



</template>

<script>
import {mapActions, mapGetters} from "vuex";

var stripe = Stripe(stripeKey);
var elements = stripe.elements();
export default {
  name: "payment",
  data(){
    return {
      paymentIntent: null,
      elements: null,
      paymentElement: null,
      showPaymentForm: false,
      isLoading: false,
      isValidated: false,
    }
  },
  computed: {
    ...mapGetters({
      clientSecret: "getClientSecret",
      product:'getProduct',
      subProducts:'getSubProducts',
      orderDetails:'getDetails',
      information:'getInformation',
    }),
    submitLabel(){
      return (!this.isLoading) ? 'Betal' : 'Bearbejder betaling';
    },
  },
  methods:{
    ...mapActions(['setInvoice', 'setInvoiceLink', 'setStep', 'setLockBody', 'setCardError', 'setCardToken', 'setClientSecret']),
    goBack(){
      if(!this.isLoading)
      {
        this.setStep(2);
      }
    },
    pay(){
      if(!this.isValidated && this.isLoading) return;

      this.isLoading = true;

      stripe.confirmPayment({
        elements: this.elements,
        confirmParams: {
          return_url: 'https://event.naesbyhovedskov.dk',
          payment_method_data:{
            billing_details:{
              name: `${this.information.firstname} ${this.information.lastname}`,
              address:{
                line1: this.information.address,
                postal_code: this.information.zipcode,
                city: this.information.city,
                country: 'DK'
              },
              email: this.information.email,
              phone: this.information.phone,
            }
          }
        },
        redirect: 'if_required',
      }).then(result => {
        if(result.error){
          this.setCardError(result.error)
          this.setStep(5);
        }else{
          axios.post('/api/order', {
            information:this.information,
            orderDetails:this.orderDetails,
            cardToken:result.paymentIntent.id,
            confirmation: true,
          }).then(response => {
            this.setInvoice(response.data.data.invoice);
            this.setInvoiceLink(response.data.data.download_url);
            this.$ua.trackEvent('Link', 'Click', 'Shop - Step 4 - Payment');
            this.setStep(4);
            this.isLoading = false;
          }).catch(error => {
            console.log(error.response);
            const response = error.response;
            if(_.has(response.data, 'errors'))
            {
              if(_.has(response.data.errors, 'exception'))
              {
                Bugsnag.notify("OrderErrorWithApiResponse", `${response.data.errors.exception.jsonBody.error.code}`)
                this.errors = response.data.errors.exception.jsonBody.error;
                this.setCardError(this.errors);
              }
              else{
                Bugsnag.notify("OrderErrorWithUnhandledApiResponse", `Response: ${response}`);
              }
            }else{
              Bugsnag.notify("UnknownOrderErrorOrTimeout", `Response: ${response}`);
            }

            this.setStep(5);
            this.isLoading = false;
          });
        }
      })

    }
  },
  mounted() {
    const appearance = {
      theme: 'minimal',
      variables: {
        fontFamily: "'Work Sans', sans-serif",
        fontSize: '16px',
        fontWeight: '300',
        color: '#4a4847',
        colorBackground: '#ece6df',
       /* '::placeholder': {
          color: "#bcb9b8",
        }*/
      }
    };

    this.elements = stripe.elements({ clientSecret: this.clientSecret, appearance });
    this.paymentElement = this.elements.create("payment");

    this.paymentElement.on('ready', ()=>{
      this.showPaymentForm = true;
    });

    this.paymentElement.on('change', event => {
      if(event.error || !event.complete){
        this.isValidated = false;
      }else if(event.complete){
        this.isValidated = true;
      }
    });

    this.paymentElement.mount("#payment-element");
  }
}
</script>

<style scoped>

</style>
